import { lazyWithRetry } from 'src/react-app/utilits/lazy-with-retry'

export const ProductDetailAsync = lazyWithRetry(() => import('./product-detail'))
